import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockSectionLayoutProps } from '@ts-blocks/block-section-layout/interfaces'
import type { SectionBannerCompactProps } from '@ts-sections/section-banner-compact/interfaces'

interface SectionBannerCompactHookOptions {
  section: () => SectionBannerCompactProps
}

interface SectionBannerCompactHookReturn {
  refBackgroundColor: ComputedRef<NonNullable<BlockSectionLayoutProps['backgroundColor']>>
}

export const useSectionBannerCompact = ({ section }: SectionBannerCompactHookOptions): SectionBannerCompactHookReturn => {
  const refBackgroundColor = computed<NonNullable<BlockSectionLayoutProps['backgroundColor']>>(() => (
    section().layout?.backgroundColor ?? 'secondary'
  ))

  return {
    refBackgroundColor,
  }
}
